import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import Tabela2 from "../../../Componentes/Utils/Tabela2";
import axios from "axios";
import { useEffect, useState } from "react";
import ModalNovaCategoria from "./ModalNovaCategoria";
import { GoTrash } from "react-icons/go";
import ModalDeleteCategoria from "./ModalDeleteCategoria";
import ModalCatalogoTipoRisco from "./ModalCatalogoTipoRisco";

const CabecalhoModal = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
`
const TituloModal = styled.h1`
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    color: #333;
`
const BotaoAdd = styled.button`
    background-color: #007bff;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    &:hover {
        background-color: #0056b3;
    }
`
const Container = styled.div`
    width: 100%;
    height: 350px;
`
const ContainerIconeDelete = styled.div`
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
`
const IconeDelete = styled(GoTrash)`
    color: red;
    cursor: pointer;
    width: 100%;
    height: 100%;
    transition: all 0.2s ease-in-out;
    &:hover {
        opacity: 0.7;
        scale: 1.1;
    }
`

const ModalCatalogoCategRisco = () => {

    const { closeModal, isModalOpen, openModal } = useModal();

    const [ categorias, setCategorias ] = useState([]);

    const getData = async () => {

        try {

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/Categorias/');
            setCategorias(data);

        } catch (error) {
            console.error(error);
        }

    }

    useEffect(() => {

        getData();

    }, []);

    const [ selectedCategoria, setSelectedCategoria ] = useState(null);

    const openDeleteModal = ( e, obj ) => {

        e.stopPropagation();

        setSelectedCategoria( obj );
        openModal('modalDeleteCategoriaRiscoDesvios');

    }

    const closeDeleteModal = () => {

        setSelectedCategoria( null );
        closeModal();

    }

    const openTiposRiscoModal = ( obj ) => {

        setSelectedCategoria( obj );
        openModal('modalTiposRiscoDesvios');

    }

    const closeTiposRiscoModal = () => {

        setSelectedCategoria( null );
        closeModal();

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="lg" header close={closeModal} >
                    <CabecalhoModal>
                        <TituloModal>Catálogo de Categoria de Risco</TituloModal>
                        <BotaoAdd onClick={() => openModal('modalNovaCategoriaRiscoDesvios')}>Adicionar</BotaoAdd>
                    </CabecalhoModal>
                    <Container>
                        <Tabela2>
                            <thead>
                                <tr>
                                    <th>CATEGORIA</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    categorias.map(( cat ) => (
                                        <tr
                                            key={ cat.uuid }
                                            onClick={() => openTiposRiscoModal(cat)}
                                        >
                                            <td>{ cat.nome } ( {cat.tipos} )</td>
                                            <td>
                                                <ContainerIconeDelete>
                                                    <IconeDelete onClick={(e) => openDeleteModal(e, cat)} />
                                                </ContainerIconeDelete>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Tabela2>
                    </Container>
                </Modal>
                {
                    isModalOpen('modalNovaCategoriaRiscoDesvios') && (
                        <ModalNovaCategoria
                            updateCategorias={getData}
                        />
                    )
                }
                {
                    isModalOpen('modalDeleteCategoriaRiscoDesvios') && (
                        <ModalDeleteCategoria
                            categoria={selectedCategoria}
                            updateCategorias={getData}
                            closeModal={closeDeleteModal}
                        />
                    )
                }
                {
                    isModalOpen('modalTiposRiscoDesvios') && (
                        <ModalCatalogoTipoRisco
                            categoria={selectedCategoria}
                            fecharModal={closeTiposRiscoModal}
                            updateCategorias={ getData }
                        />
                    )
                }
            </Overlay>
        </>
    )
}

export default ModalCatalogoCategRisco;